import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

const CallTimer = function CallTimer({ startTime, stopTime }) {
  const intervalRef = useRef(0);
  const [time, setTime] = useState(0);

  useEffect(() => {
    if (startTime) {
      const interval = setInterval(() => {
        setTime(Date.now());
      }, 1000);
      intervalRef.current = interval;
    }
  }, [startTime]);

  useEffect(() => {
    if (stopTime) {
      const interval = intervalRef.current;
      clearInterval(interval);
    }
  }, [stopTime]);

  let formattedTime = '00:00';
  if (startTime != null && time != null) {
    const totalSeconds = Math.max(0, Math.floor((time - startTime) / 1000));
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    formattedTime = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  /*  useEffect(() => {
    if (callAnsweredMinutes === null || callAnsweredMinutes === undefined)
      return;

    if (answered === null) {
      if (stopTime && startTime) {
        const callSeconds =
          Math.max(0, Math.floor((stopTime - startTime) / 1000)) % 60;

        //if the call was dropped before 3 seconds in "Connected" status automatically sets not answered.
        if (callSeconds <= callAnsweredMinutes) handleChangeAnswered(false);
      } else if (startTime != null && time != null) {
        const callSeconds =
          Math.max(0, Math.floor((time - startTime) / 1000)) % 60;

        //after 3 seconds in "Connected" status automatically sets answered.
        if (callSeconds > callAnsweredMinutes) handleChangeAnswered(true);
      }
    }
  }, [time, stopTime, callAnsweredMinutes]); */

  return <Typography variant="h6">{formattedTime}</Typography>;
};

CallTimer.propTypes = {
  startTime: PropTypes.object,
  stopTime: PropTypes.object,
  answered: PropTypes.bool,
  handleChangeAnswered: PropTypes.func, // (newValue: boolean) => void
};
export default CallTimer;
